import React, { useState } from "react";
import { Button, Image, Modal } from "react-bootstrap";
import { changeReviewStatus } from "../../../../../store/actions/SuperAdminActions/commonSuperAdmin";
import PropTypes from "prop-types";
import { connect } from "react-redux";

const HideMessage = (props) => {
  const [showHideMessage, seShowHideMessage] = useState(false);
  const handleCloseHideMessage = () => seShowHideMessage(false);
  const handleShowHideMessage = () => seShowHideMessage(true);
  const onSuccessChangeStatus = () => {
    handleCloseHideMessage();
  };
  const onErrorChangeStatus = () => {
    handleCloseHideMessage();
  };

  const onClickHideYes = () => {
    const token = props.auth.user.accessToken;
    const formData = {};
    formData.status = !props.hideStatus;
    props.changeReviewStatus(
      token,
      props.reviewId,
      formData,
      props.filterValue,
      onSuccessChangeStatus,
      onErrorChangeStatus
    );
  };

  return (
    <React.Fragment>
      <Button
        variant="link"
        className="enIconBtn"
        onClick={handleShowHideMessage}
      >
        {/* <Image
          fluid
          alt="View"
          title="View"
          src={require("../../../../../assets/images/UserManagement/close.svg")}
        /> */}
        {props.hideStatus ? (
          <i class="fa fa-eye-slash" style={{ color: "black" }}></i>
        ) : (
          <i style={{ color: "black" }} className="fa fa-eye"></i>
        )}
      </Button>
      <div className="f10-500 mt-1 cursor" onClick={handleShowHideMessage}>
        {props.hideStatus ? <>Hide Review </> : <> Unhide Review </>}
      </div>
      <Modal show={showHideMessage} onHide={handleCloseHideMessage} centered>
        <Modal.Header className="py-0 pt-2 border-0" closeButton>
          <Modal.Title></Modal.Title>
        </Modal.Header>
        <Modal.Body className="f16-500">
          {props.hideStatus ? (
            <>Are you sure you want to Hide this review ? </>
          ) : (
            <> Are you sure you want to Unhide this review</>
          )}
        </Modal.Body>
        <Modal.Footer className="justify-content-start border-0">
          <Button
            variant="outline-secondary"
            className="btn-lg mr-4 px-5"
            onClick={handleCloseHideMessage}
          >
            No
          </Button>
          <Button
            variant="danger"
            className="btn-lg px-5"
            //onClick={handleCloseHideMessage}
            onClick={() => onClickHideYes()}
          >
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
};

HideMessage.propTypes = {
  auth: PropTypes.object.isRequired,
  changeReviewStatus: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, {
  changeReviewStatus,
})(HideMessage);
